import React from "react";

const FeedBack = ({ classes, horizontalBar, time, approverName, disapproveReason, latest }) => {
  return (
    <div>
      <div className={classes.confirmBody} >
        <div className={classes.feedbackStyle}>{time}</div>
        <div className={`${classes.confirmHeader} ${latest ? classes.latestHeader : classes.pastHeader}`}><b>{approverName}</b> disapproved this event</div>
        <div>
          <div className={classes.feedbackStyle}>Feedback</div>
          <div className={`${classes.confirmFeedback} ${latest ? classes.latestFeeback : classes.pastFeeback}`} dangerouslySetInnerHTML={{ __html: disapproveReason.replace(/\n/g, "<br />") }}></div>
        </div>
      </div>
      {horizontalBar && latest && <div className={classes.bottom}>
        <div className={classes.horizontalBar}></div><div className={classes.text}>Past</div><div className={classes.horizontalBar}></div>
      </div>
      }
    </div>
  )
}

export default FeedBack;